import * as yup from 'yup';
let createRunsheetValidationForm = yup.object().shape({
  vehicle: yup.string().required('Vehicle is required'),
  driver: yup.string().required('Driver is required'),
});
let createCombineOrderValidationForm = yup.object().shape({
  driver: yup.string().required('Driver is required'),
  destination: yup.string().required('Destination is required'),
});
let createDeliveryValidationFrom = yup.object().shape({
  driver: yup.string().required('Driver is required'),
});
let vehicleValidationForm = yup.object().shape({
  emergency_contact_number: yup
    .string()
    .required('Emergency Contact Number is required'),
  license_number: yup.string().required('License Number is required'),
});
let createRiderValidationForm = yup.object().shape({
  username: yup.string().required('Username is required'),
  full_name: yup.string().required('Full Name is required'),
  mobile_number: yup.string().required('Mobile Number is required'),
  license_number: yup.string().required('License Number is required'),
  citizenship_number: yup.string().required('Citizenship Number is required'),
});
let orderRemarksValidationForm = yup.object().shape({
  comment: yup.string().required('Remarks is required'),
});

export {
  createRunsheetValidationForm,
  vehicleValidationForm,
  createRiderValidationForm,
  orderRemarksValidationForm,
  createCombineOrderValidationForm,
  createDeliveryValidationFrom,
};
